import { Theme } from '@mui/material/styles';

export const getStyles = ({ spacing }: Theme) => ({
  tabContent: {
    padding: spacing(3, 2),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: spacing(1),
    padding: spacing(2),
  },
});
